import _regeneratorRuntime from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { bytesToHex, bytesToUtf8, getGlobalObject, hexToBytes, makeUUID4, nextMonth, utf8ToBytes } from '@stacks/common';
import { decryptECIES, encryptECIES, makeECPrivateKey, publicKeyToBtcAddress } from '@stacks/encryption';
import { SECP256K1Client, TokenSigner } from 'jsontokens';
import { DEFAULT_SCOPE } from './constants';
import { makeDIDFromAddress } from './dids';
var VERSION = '1.4.0';
export function generateTransitKey() {
  var transitKey = makeECPrivateKey();
  return transitKey;
}
export function makeAuthRequest(transitPrivateKey, redirectURI, manifestURI) {
  var scopes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_SCOPE.slice();
  var appDomain = arguments.length > 4 ? arguments[4] : undefined;
  var expiresAt = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : nextMonth().getTime();
  var extraParams = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};

  var getWindowOrigin = function getWindowOrigin(paramName) {
    var location = getGlobalObject('location', {
      throwIfUnavailable: true,
      usageDesc: "makeAuthRequest([".concat(paramName, "=undefined])")
    });
    return location === null || location === void 0 ? void 0 : location.origin;
  };

  if (!redirectURI) {
    redirectURI = "".concat(getWindowOrigin('redirectURI'), "/");
  }

  if (!manifestURI) {
    manifestURI = "".concat(getWindowOrigin('manifestURI'), "/manifest.json");
  }

  if (!appDomain) {
    appDomain = getWindowOrigin('appDomain');
  }

  var payload = Object.assign({}, extraParams, {
    jti: makeUUID4(),
    iat: Math.floor(new Date().getTime() / 1000),
    exp: Math.floor(expiresAt / 1000),
    iss: null,
    public_keys: [],
    domain_name: appDomain,
    manifest_uri: manifestURI,
    redirect_uri: redirectURI,
    version: VERSION,
    do_not_include_profile: true,
    supports_hub_url: true,
    scopes: scopes
  });
  var publicKey = SECP256K1Client.derivePublicKey(transitPrivateKey);
  payload.public_keys = [publicKey];
  var address = publicKeyToBtcAddress(publicKey);
  payload.iss = makeDIDFromAddress(address);
  var tokenSigner = new TokenSigner('ES256k', transitPrivateKey);
  var token = tokenSigner.sign(payload);
  return token;
}
export function encryptPrivateKey(_x, _x2) {
  return _encryptPrivateKey.apply(this, arguments);
}

function _encryptPrivateKey() {
  _encryptPrivateKey = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(publicKey, privateKey) {
    var encryptedObj, encryptedJSON;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return encryptECIES(publicKey, utf8ToBytes(privateKey), true);

          case 2:
            encryptedObj = _context.sent;
            encryptedJSON = JSON.stringify(encryptedObj);
            return _context.abrupt("return", bytesToHex(utf8ToBytes(encryptedJSON)));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _encryptPrivateKey.apply(this, arguments);
}

export function decryptPrivateKey(_x3, _x4) {
  return _decryptPrivateKey.apply(this, arguments);
}

function _decryptPrivateKey() {
  _decryptPrivateKey = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(privateKey, hexedEncrypted) {
    var unhexedString, encryptedObj, decrypted;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            unhexedString = bytesToUtf8(hexToBytes(hexedEncrypted));
            encryptedObj = JSON.parse(unhexedString);
            _context2.next = 4;
            return decryptECIES(privateKey, encryptedObj);

          case 4:
            decrypted = _context2.sent;

            if (!(typeof decrypted !== 'string')) {
              _context2.next = 9;
              break;
            }

            throw new Error('Unable to correctly decrypt private key');

          case 9:
            return _context2.abrupt("return", decrypted);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _decryptPrivateKey.apply(this, arguments);
}

export function makeAuthResponse(_x5) {
  return _makeAuthResponse.apply(this, arguments);
}

function _makeAuthResponse() {
  _makeAuthResponse = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(privateKey) {
    var profile,
        metadata,
        coreToken,
        appPrivateKey,
        expiresAt,
        transitPublicKey,
        hubUrl,
        blockstackAPIUrl,
        associationToken,
        appPrivateKeyFromWalletSalt,
        publicKey,
        address,
        privateKeyPayload,
        coreTokenPayload,
        additionalProperties,
        payload,
        tokenSigner,
        _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            profile = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
            metadata = _args3.length > 2 ? _args3[2] : undefined;
            coreToken = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : null;
            appPrivateKey = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : null;
            expiresAt = _args3.length > 5 && _args3[5] !== undefined ? _args3[5] : nextMonth().getTime();
            transitPublicKey = _args3.length > 6 && _args3[6] !== undefined ? _args3[6] : null;
            hubUrl = _args3.length > 7 && _args3[7] !== undefined ? _args3[7] : null;
            blockstackAPIUrl = _args3.length > 8 && _args3[8] !== undefined ? _args3[8] : null;
            associationToken = _args3.length > 9 && _args3[9] !== undefined ? _args3[9] : null;
            appPrivateKeyFromWalletSalt = _args3.length > 10 && _args3[10] !== undefined ? _args3[10] : null;
            publicKey = SECP256K1Client.derivePublicKey(privateKey);
            address = publicKeyToBtcAddress(publicKey);
            privateKeyPayload = appPrivateKey;
            coreTokenPayload = coreToken;
            additionalProperties = {};

            if (!(appPrivateKey !== undefined && appPrivateKey !== null)) {
              _context3.next = 27;
              break;
            }

            if (!(transitPublicKey !== undefined && transitPublicKey !== null)) {
              _context3.next = 24;
              break;
            }

            _context3.next = 19;
            return encryptPrivateKey(transitPublicKey, appPrivateKey);

          case 19:
            privateKeyPayload = _context3.sent;

            if (!(coreToken !== undefined && coreToken !== null)) {
              _context3.next = 24;
              break;
            }

            _context3.next = 23;
            return encryptPrivateKey(transitPublicKey, coreToken);

          case 23:
            coreTokenPayload = _context3.sent;

          case 24:
            additionalProperties = {
              email: (metadata === null || metadata === void 0 ? void 0 : metadata.email) ? metadata.email : null,
              profile_url: (metadata === null || metadata === void 0 ? void 0 : metadata.profileUrl) ? metadata.profileUrl : null,
              hubUrl: hubUrl,
              blockstackAPIUrl: blockstackAPIUrl,
              associationToken: associationToken,
              version: VERSION
            };
            _context3.next = 27;
            break;

          case 27:
            payload = Object.assign({}, {
              jti: makeUUID4(),
              iat: Math.floor(new Date().getTime() / 1000),
              exp: Math.floor(expiresAt / 1000),
              iss: makeDIDFromAddress(address),
              private_key: privateKeyPayload,
              public_keys: [publicKey],
              appPrivateKeyFromWalletSalt: appPrivateKeyFromWalletSalt,
              profile: profile,
              core_token: coreTokenPayload
            }, additionalProperties);
            tokenSigner = new TokenSigner('ES256k', privateKey);
            return _context3.abrupt("return", tokenSigner.sign(payload));

          case 30:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _makeAuthResponse.apply(this, arguments);
}